import { useAuth0 } from '@auth0/auth0-react';
import { Button, Grid, styled, Typography, Stack } from '@mui/material';
import Rating from '@mui/material/Rating';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ratingComplete } from '../../redux/BookingSlice';
import LimitedTextField from '../BasicComponents/LimitedTextField';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: 0,
}));

export const SchoolRating = props => {
    const dispatch = useDispatch();
    // const classes = useStyles();
    const { getAccessTokenSilently } = useAuth0();

    const [state, setState] = useState({
        textToUpload: '',
        uploadingState: 'Not Started',
        schoolPreBookingUpload: 'incomplete',
        teacherRating: 5,
        teacherRatingComments: '',
    });
    const [submitDisabled, setSubmitDisabled] = useState(true);
    // const [pendingReview, setpendingReview] = useState({
    //     btnApproveLoad: false,
    //     btnRejectLoad: false,
    // });

    const bookingText = event => {
        setState({
            ...state,
            teacherRatingComments: event.target.value,
        });
    };
    const handleSubmission = async val => {
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        setState({
            ...state,
            uploadingState: 'Adding Rating to Booking',
        });
        try {
            const document = {
                teacherRating: state.teacherRating,
                sk1: props.sk1,
                pk1: props.pk1,
                teacherRatingComments: state.teacherRatingComments,
                schoolName: props.schoolName,
                id: props.id,
                rejectReview: val === 'reject',
                userRole: props.role,
            };
            const ratingUpdate = await axios.post(
                '/uploadSchoolRating',
                document,
                {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    timeout: 30000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            console.log(JSON.stringify(ratingUpdate));
            setState({
                ...state,
                uploadingState: val === 'reject' ? 'Not Started' : 'Completed',
                teacherRating: val === 'reject' ? 5 : state.teacherRating,
                teacherRatingComments:
                    val === 'reject' ? '' : state.teacherRatingComments,
            });
            dispatch(
                ratingComplete({
                    teacherRating: state.teacherRating,
                    status:
                        props.role !== 'admin'
                            ? 'Pending Review'
                            : val === 'reject'
                            ? 'Completed'
                            : '',
                    id: props.id,
                    teacherRatingComments: state.teacherRatingComments,
                })
            );
        } catch (err) {
            console.log(err);
            setState({
                ...state,
                uploadingState: 'Failed',
            });
        }
    };

    useEffect(() => {
        state.teacherRating < 5 && state.teacherRatingComments === ''
            ? setSubmitDisabled(true)
            : setSubmitDisabled(false);
    }, [state.teacherRating, state.teacherRatingComments]);

    useEffect(() => {
        if (typeof props.teacherRating !== 'undefined') {
            setState({
                ...state,
                schoolPreBookingUpload: 'complete',
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    useEffect(() => {
        console.log('props.pendingReview', props.pendingReview);

        if (
            typeof props.pendingReview !== 'undefined' &&
            props.pendingReview !== '' &&
            typeof props.status !== 'undefined' &&
            props.status === 'Pending Review'
        ) {
            setState({
                ...state,
                teacherRating: props.pendingReview[0].teacherRating,
                teacherRatingComments:
                    props.pendingReview[0].teacherRatingComments,
            });
        }

        //if admin reject the ratings status back to completed
        if (
            typeof props.pendingReview !== 'undefined' &&
            props.pendingReview !== '' &&
            typeof props.status !== 'undefined' &&
            props.status === 'Completed'
        ) {
            setState({
                ...state,
                teacherRating: 5,
                teacherRatingComments: '',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status]);

    return (
        <Grid
            data-cy="action-needed"
            container
            sx={{
                '& > *': {
                    margin: theme => theme.spacing(0.5),
                },
            }}
        >
            <Grid item xs={12}>
                <Typography variant="h4" color="secondary">
                    Action Needed
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6">Provide Teacher Rating</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="body">
                    Please rate the replacement teacher. Ensure comments are
                    assistive to a teachers improvement.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Rating
                    data-cy="rating"
                    name="simple-controlled"
                    value={state.teacherRating}
                    precision={0.5}
                    onChange={(event, newRating) => {
                        setState({
                            ...state,
                            teacherRating: newRating,
                        });
                    }}
                    color="primary"
                    size="large"
                    disabled={
                        state.uploadingState === 'Completed' ||
                        state.uploadingState === 'Writing to Booking' ||
                        (props.pendingReview !== '' && props.role !== 'admin')
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <LimitedTextField
                    data-cy="review-comments"
                    label="Review Comments"
                    error={
                        state.teacherRatingComments === '' &&
                        state.teacherRating < 5
                    }
                    errorText={
                        state.teacherRatingComments === '' &&
                        state.teacherRating < 5
                            ? 'Comments must be added for ratings below 5'
                            : ''
                    }
                    value={state.teacherRatingComments}
                    width="100%"
                    updateField={bookingText}
                    textLength={1000}
                    disabled={
                        state.uploadingState === 'Completed' ||
                        state.uploadingState === 'Writing to Booking' ||
                        (props.pendingReview !== '' && props.role !== 'admin')
                    }
                />
            </Grid>

            <Grid item xs={12}>
                {props.pendingReview !== '' && props.role === 'admin' && (
                    <Grid container alignItems="center" justifyContent="center">
                        <Stack spacing={2} direction="row" sx={{ m: 2 }}>
                            <StyledButton
                                variant="outlined"
                                color="secondary"
                                size="large"
                                onClick={() => handleSubmission('submit')}
                                disabled={
                                    state.uploadingState === 'Completed' ||
                                    state.uploadingState ===
                                        'Writing to Booking' ||
                                    submitDisabled
                                }
                                startIcon={
                                    <CheckCircleOutlineIcon color="sexysuccess" />
                                }
                            >
                                Approve
                            </StyledButton>
                            <StyledButton
                                color="secondary"
                                variant="contained"
                                size="large"
                                onClick={() => handleSubmission('reject')}
                                disabled={
                                    state.uploadingState === 'Completed' ||
                                    state.uploadingState ===
                                        'Writing to Booking' ||
                                    submitDisabled
                                }
                                startIcon={
                                    <RemoveCircleOutlineIcon color="sexyerror" />
                                }
                            >
                                {' '}
                                Reject
                            </StyledButton>
                        </Stack>
                    </Grid>
                )}
                {props.pendingReview === '' && (
                    <BookingButton
                        variant="contained"
                        onClick={() => handleSubmission('submit')}
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking' ||
                            submitDisabled
                        }
                    >
                        Submit
                    </BookingButton>
                )}
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2">
                    Progress: {state.uploadingState}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default SchoolRating;
